import { OidcClient } from '@axa-fr/react-oidc';
import { v4 as uuid } from 'uuid';

import type { SourceAppViewType } from '@shared/constants/constants';
import { LayoutViewBridge } from '@shared/context';

import { API_KEY } from './URL';

const CONTENT_TYPE = 'application/json';

/**
 * Request options without an Authorization header.
 *
 * For callers that run outside the <OidcProvider> tree, where OidcClient.get()
 * would throw: i18n initializes at module load, before the provider mounts.
 */
const getPublicRequestOptions = (
  withCredentials: boolean,
  IsIncludeClientMessageId = true,
  customSourceApp?: SourceAppViewType
) => {
  const guid = uuid();
  const { sourceAppView } = LayoutViewBridge.getLayoutViewBridge?.() ?? {};

  return {
    headers: {
      'Content-Type': CONTENT_TYPE,
      'X-Api-Key': API_KEY,
      'X-HH-Agent': navigator.userAgent,
      'X-HH-SourceApp': customSourceApp ?? sourceAppView,
      ...(IsIncludeClientMessageId && { 'X-HH-MessageId': guid }),
    },
    withCredentials,
  };
};

const getRequestOptions = (
  withCredentials: boolean,
  IsIncludeClientMessageId = true,
  customSourceApp?: SourceAppViewType
) => {
  const oidc = OidcClient.get();
  const { headers, ...options } = getPublicRequestOptions(withCredentials, IsIncludeClientMessageId, customSourceApp);

  return {
    ...options,
    headers: {
      ...headers,
      ...(oidc.tokens?.accessToken && { Authorization: `Bearer ${oidc.tokens?.accessToken}` }),
    },
  };
};

export { getPublicRequestOptions, getRequestOptions };
